export const LANGUAGES = [
    { label: 'Eng (US)', code: 'en' },
    { label: 'Spanish (ES)', code: 'es' },
];
